import React, { useState } from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import api from './api/client';
import { parse, format } from 'date-fns'; // Добавляем этот импорт


const ScannersInvMaterials = () => {
    const [scannedData, setScannedData] = useState('');
    const [entries, setEntries] = useState(new Set());
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const parseScannedData = (data) => {
        const lines = data.split('\n').map(line => line.trim()).filter(line => line);
        const parsedEntries = [];
        const errors = [];
    
        lines.forEach((line, index) => {
            try {
                const regex = /(\d+)-Box:(\d+);([^,]+(?:,\s*[^,]+)*)\s(\d{4}\/\d{2}\/\d{2})\s(\d{2}:\d{2}:\d{2})/;
                const match = line.match(regex);
    
                if (!match) {
                    throw new Error(`Row ${index + 1}: Invalid format.`);
                }
    
                const [_, scanner, box, skuData, dateStr, time] = match;
    
                // Преобразование даты
                const parsedDate = parse(dateStr, 'yyyy/MM/dd', new Date());
                if (isNaN(parsedDate)) {
                    throw new Error(`Row ${index + 1}: Invalid date format.`);
                }
                const formattedDate = format(parsedDate, 'yyyy-MM-dd');
    
                // Обработка SKU
                const skus = skuData.split(',').map((skuItem, skuIndex) => {
                    const skuMatch = skuItem.trim().match(/([^/]+)\/(\d+)/);
                    if (!skuMatch) {
                        throw new Error(`Row ${index + 1}: Invalid SKU format in SKU ${skuIndex + 1}.`);
                    }
                    const [__, sku, qty] = skuMatch;
                    return {
                        skunum: skuIndex + 1,
                        sku: sku.trim(),
                        qty: parseInt(qty, 10)
                    };
                });
    
                skus.forEach(({ skunum, sku, qty }) => {
                    parsedEntries.push({
                        scanner: parseInt(scanner, 10),
                        box: parseInt(box, 10),
                        sku,
                        qty,
                        date: formattedDate,
                        time,
                        skunum
                    });
                });
            } catch (error) {
                errors.push(error.message);
            }
        });
    
        if (errors.length > 0) {
            alert(`Errors occurred:\n${errors.join('\n')}`);
        }
    
        return parsedEntries;
    };
    
    
    const handleSave = async () => {
        setError('');
        setSuccess(false);
    
        try {
            const parsedData = parseScannedData(scannedData);
    
            if (!parsedData || parsedData.length === 0) { // Проверка на пустые данные
                setError('No valid entries to save.');
                return;
            }
    
            // Отправка данных на сервер
            await api.post(`/api/scannersinvmaterials`, { data: parsedData });
    
            setSuccess(true);
            setScannedData('');
            setEntries(prevEntries => new Set([...prevEntries, ...parsedData]));
        } catch (err) {
            setError('Failed to save data.');
            console.error(err);
        }
    };
    
    

    return (
        <div className="scanners-inv-seeds-page-bg">
            <HeaderLogged />
            <Container>
                <div className="scan-sealed-sets">
                    <h1 className="scan-sealed-sets-h">Scan the QR code on the box to add the small bags to inventory.</h1>
                    <ol className="entries-list">
                        <li>Please Scan QR on the Box with Small Packets</li>
                    </ol>
                    <textarea
                        value={scannedData}
                        onChange={(e) => setScannedData(e.target.value)}
                        placeholder="Scan QR code on the box"
                        className="scanned-input"
                    ></textarea>
                    <button onClick={handleSave} className="save-btn">Save</button>
                    {success && <p style={{ color: 'green' }}>Data saved successfully!</p>}
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </div>
            </Container>

            <style jsx>{`
                .scan-sealed-sets {
                    margin-top: 150px;
                    z-index: 1;
                    position: relative;
                }
                .scan-sealed-sets-h {
                    margin-bottom: 20px;
                    color: #404340;
                    text-transform: uppercase;
                    font-weight: bold;
                }
                .scanned-input {
                    width: 100%;
                    height: 100px;
                    padding: 10px;
                    border: 1px solid #4caf50;
                    border-radius: 5px;
                    margin-bottom: 10px;  
                }
                .add-entry-btn, .save-btn {
                    background-color: #4caf50;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    margin-top: 10px;
                }
                .add-entry-btn:hover, .save-btn:hover {
                    background-color: #45a049;
                }
                .entries-list {
                    margin-top: 10px;
                    list-style-type: none;
                    padding: 0;
                }
                .entries-list li {
                    background-color: #e8f5e9;
                    padding: 10px;
                    border: 1px solid #c8e6c9;
                    border-radius: 5px;
                    margin-bottom: 5px;
                }
            `}</style>
        </div>
    );
};

export default ScannersInvMaterials;
